import { createSlice } from '@reduxjs/toolkit';
import { PO_EDIT_MODE } from '../../define/global';
import { convFileNameHWPXToHWP } from '../../utils/FileControlUtil';
import { createSelectorFn } from './common';

const initialState = {
  fileName: '',
  poEditMode: PO_EDIT_MODE.NONE,
  isSaved: false
};

const docInfoSlice = createSlice({
  name: 'docInfo',
  initialState,
  reducers: {
    setFileName: (state, action) => {
      state.fileName = convFileNameHWPXToHWP(action.payload);
    },
    setEditMode: (state, action) => {
      state.poEditMode = action.payload;
    },
    setSaved: (state, action) => {
      state.isSaved = action.payload;
    }
  }
});

export const { setFileName, setEditMode, setSaved } = docInfoSlice.actions;
export const useDocInfoSliceSelector = createSelectorFn(docInfoSlice);

export default docInfoSlice;
